const lan = {
  REDIRECT: "جاري إعادة التوجيه...",
  RULE: {
    SERVICE_TYPE: "الرجاء تحديد نوع الخدمة",
    COUNTRY: "الرجاء تحديد بلدك أو منطقتك",
    USERNAME: "إسم المستخدم مطلوب",
    EMAIL: "البريد الإلكتروني مطلوب",
    EMAIL2: "الرجاء إدخال تنسيق البريد الإلكتروني الصحيح.",
    PRODUCT: "الرجاء إختيار المنتج",
    PRODUCTSN: "الرجاء إدخال الرقم التسلسلي للمنتج الخاص بك",
    PRODUCTSN_LEN: "الرجاء إدخال 12 إلى 15 حرف أو أرقام",
    BIRTHDAY: "تاريخ الميلاد مطلوب",
    REQUIRED: "مطلوب",
  },
  SYS: {
    HEAD: "النظام",
    NOSERVICE: "عذراً، محادثة ASUS للبلد أو المنطقة المحددة غير متوفرة.",
    CHECK_FILESIZE: "الرجاء التحقق من حجم الصورة والملف. محدود:",
    RECONNECTED: "حالة الاتصال قد عادت إلى الوضع الطبيعي",
    UNABLE_SEND: "تعذر تحميل المرفقات",
    NO_NETWORK: "لا يوجد اتصال بالإنترنت",
    NO_NETWORK_INFO:
      "لا يوجد اتصال بالإنترنت. اتصل بالإنترنت ثم حاول مرة أخرى.",
  },
  IDLE: {
    HEAD: "لقد كنت خاملا لبعض الوقت. هل تريد متابعة الدردشة؟",
    BUTTON: "متابعة",
  },
  DISCONNECT: {
    HEAD: "انتهت الدردشة",
    BUTTON: "إنهاء",
  },
  LAYOUT: {
    STEP_1: "اختر المنتج",
    STEP_2: "شروط الخدمة",
    STEP_3: "تسجيل الدخول",
    STEP_4: "معلومات",
    SELECT_SKILL: "اختر المنتج",
    PREV_STEP: "السابق",
    NEXT_STEP: "التالي",
    NOTSET: "لم يتم التعيين.",
    AGREEN: "موافق",
    NOTAGREEN: "غير موافق",
    LEAVE: "مغادرة",
    TYPE_HERE: "أكتب هنا",
    CHAT_DOWNLOAD:
      "الرجاء النقر هنا لحفظ نسخة من محادثتك مع خدمة العملاء ASUS على الإنترنت.",
  },
  COUNTRY: { SELECT_COUNTRY: "الرجاء تحديد منطقة الخدمة" },
  POLICY: {
    PRIVACY: "سياسة حماية الخصوصية",
    SAT_SURVEY: "اتفاقية الخدمة",
    CONFIRM_COUNTRY: {
      H1: "عزيزي عميل ASUS،",
      P1:
        "أنت الآن تزور خدمة العملاء ASUS على الإنترنت لأستراليا، التي تختلف عن منطقتك الحالية. ووفقاً لشروط الضمان في الولايات المتحدة الأمريكية، لا ينطبق كل منتج من منتجات التأمين الاجتماعي الأمريكي على خدمة الضمان والدعم الدولية في الولايات المتحدة. إذا كان الموقع الإقليمي أعلاه الذي تزوره ليس المنطقة التي اشتريت فيها منتج ASUS الخاص بك أو يختلف عن منطقتك الحالية، قد يؤثر على حقوقك. يمكنك الاستمرار في استخدام خدمة العملاء ASUS على الإنترنت لأستراليا أو تغيير خدمة العملاء ASUS على الإنترنت إلى منطقتك.",
      P2: "",
      P3: "",
      B1: "قم بالتبديل إلى ASUS",
      B2: "موقع الكتروني",
      B3: "متابعة الاستخدام",
    },
    BULLETIN: {
      HEAD: "إشعار برسالة هامة",
      CONFIRM: "حسنا، فهمت ذلك",
    },
  },
  SURVEY: {
    SURVEY_ENTER: "يرجى ملء بيانات الاتصال",
    SURVEY_TYPE: "الرجاء تحديد نوع الخدمة",
    PROBLEM_BRIEF: "كيف تصف مشكلتك ؟",
    TYPE1: "سؤال عام",
    TYPE2: "استفسار الإصلاح",
    TYPE3: "الدعم الفني",
    TYPE4: "استفسار عن الضمان",
    TYPE5: "معلومات و ملاحظات",
    EC_TYPE1: "معلومات المنتجات والمبيعات",
    EC_TYPE2: "نشاط التسويق",
    EC_TYPE3: "حالة الشحن والطلب",
    EC_TYPE4: "خدمة المرتجع",
    SIGNUPDATA: "معلومات التسجيل",
    NAME: "الاسم",
    TEL: "رقم الهاتف",
    ORDER_NO: "رقم الطلب",
    BIRTHDAY: "تاريخ الميلاد",
    LABEL_EMAIL: "البريد الإلكتروني",
    EMAIL: "البريد الإلكتروني",
    DEVICEINFO: "معلومات المنتج",
    DEVICENAME: "اسم المنتج",
    MY_DEVICE: "المنتج الخاص بك ",
    MY_DEVICE_SELECT: "ختار المنتج الخاص بك ",
    MY_DEVICE_EMPTY: "لا تملك أي جهاز حاليا",
    LABEL_DEVICESN: "الرقم التسلسلي ",
    DEVICESN: "رقم التسلسل للمنتج",
    DEVICESN_ERROR: "الرقم التسلسلي الذى ادخلته غير صحيح",
    PREPARE: "إنشاء غرفة الدردشة، والاستعداد للدردشة",
    START: "بدء المحادثة",
    AGE_LIMIT: "حد العمر",
    AGE_LIMIT_DESC: "أنت لا تستوفي شروط العمر لاستخدام دردشة ASUS",
    REPEAT_ENTRY: {
      H1: "تم اكتشاف غرفة الدردشة الموجودة",
      P1:
        "هل أنت متأكد من أنك تريد بدء محادثة جديدة؟ عند فتح محادثة جديدة، ستنتهي المحادثة القديمة.",
      B0: "تأكيد",
      B1: "إلغاء",
    },
  },
  CONNECTTING: {
    P1: "الرجاء الانتظار لحظات، ولا تغلق النافذة",
    P2: "دردشة ASUS تقوم بتوصيلك إلى وكيل متاح",
    NOTE: "نصائح",
    BEFORE_LEAVE: "هل تريد بالتأكيد مغادرة هذه الدردشة؟",
    B0: "إنهاء",
    B1: "البقاء والانتظار",
  },
  OFFLIEN: {
    OTHER_CONTACT: "الاتصال ASUS عبر قنوات أخرى",
    MAIL: "تواصل معنا عبر البريد الإلكتروني",
    TEL: "اتصل بنا",
    CLOSE: "إغلاق",
  },
  WAITTING: {
    WATTING_NUM: "المرتبة في قائمة الانتظار",
    PEOPLE: "العميل",
    NOTE: "نصائح",
    BEFORE_LEAVEL: "هل أنت متأكد من الخروج من قائمة الانتظار؟",
    LEAVE_DESC: "إذا لم تعد ترغب في الإنتظار، يمكنك إنهاء الدردشة",
    LEAVE: "إنهاء الدردشة",
    STAY: "البقاء في قائمة الانتظار",
  },
  CHATROOM: {
    TYPING: "الوكيل يكتب...",
    HEAD: {
      CLOSE_AMD_SURVEY: "إنهاء الدردشة وبدء الاستطلاع",
      TERMINATE: "إنهاء الدردشة",
    },
    FOOTER: { CHAT_FINISH: "انتهت الدردشة" },
    FINISH: "انتهت الدردشة. هل أنت بحاجة إلى أي خدمة إضافية أو دعم؟",
    SAT_SURVEY: {
      SAT: "راض",
      DISSAT: "غير راضي",
      SAT_CHOOSE: "أي نوع من الخدمات؟ (متعددة)",
      HEAD: "هل كنت راض عن الدردشة؟",
      DESC:
        "الاستماع إلى ملاحظاتك هو القوة الدافعة لتحسيننا المستمر. إذا كان لديك أي اقتراحات لخدمات أو دعم ASUS، يرجى إعلامنا.",
      OTHER_OPTION: "أخرى",
      OTHER_REASON: "يرجى ملء السبب الآخر",
      SEND: "إرسال",
    },
    CLOSE: {
      TITLE: "هل أنت متأكد أنك تريد إنهاء هذه الدردشة؟",
      P1:
        'انقر فوق "إنهاء" لإغلاق النافذة. إذا كنت بحاجة إلى استخدام الدردشة مرة أخرى، ستحتاج إلى طلب آخر للمحادثة".',
      B0: "إنهاء",
      B1: "إلغاء",
    },
  },
  ERROR: {
    H1: "غرفة الدردشة غير موجودة أو أن الدردشة قد انتهت بالفعل",
    CLOSE: "أغلاق النافذة",
  },
  CHAT_END: {
    H1: "شكرا جزيلا، لقد انتهت الدردشة الآن",
    CLOSE: "أغلاق النافذة",
  },
  CHAT_CLOSE: {
    H1:
      "لقد توقفت شبكة الاتصال الخاصة بك لأكثر من 300 ثانية، لذلك قمنا بإنهاء هذه المحادثة.",
    DESC:
      "إذا كنت تستخدم شبكة لاسلكية أو شبكة محمولة، يرجى محاولة العثور على موقع يحتوي على إشارة أفضل؛ أو قم بالتبديل إلى اتصال شبكة سلكية، عذراً على الإزعاج",
    CLOSE: "أغلاق النافذة",
  },
  SURVEY_DONE: {
    H1: "شكرا لكم. لقد أكملت استقصاء مدى رضا الخدمة",
    P1:
      'ملاحظاتك هي القوة الدافعة لتحسيننا المستمر. نشكرك على تخصيص الوقت لإكمال استقصاء رضا الخدمات. إذا كنت بحاجة إلى أي خدمة أو دعم إضافي، يرجى النقر فوق "بدء محادثة جديدة". إذا قمنا بحل الاستعلام الخاص بك، يرجى النقر فوق "إغلاق النافذة" لإنهاء المحادثة',
    AGAIN: "بدء دردشة جديدة",
    CLOSE: "أغلاق النافذة",
    YT_H1: "اكتشف النصائح والخبرات التقنية من خلال مقاطع فيديو دعم ASUS.",
    YT_H2: "اضغط للاستكشاف!",
  },
  AGENT_OFFLINE: {
    H1: "اتصال الوكيل بالإنترنت لا يستجيب؛ محادثتك مقطوعة حاليا",
    H2: "أرجو ألا تغلق النافذة؛ ونحن نعمل جاهدين لاستئناف الدردشة",
    DESC:
      "يمكنك أيضًا اختيار إنهاء الجلسة لإجراء استقصاء، أو انقر فوق 'بدء محادثة جديدة', وسنعين فوراً وكيلاً جديداً لمواصلة الدورة. نأسف لأي إزعاج يسببه",
    AGAIN: "بدء دردشة جديدة",
  },
  VIDEOCALL: {
    MEDIA_NOTALLOW: "تعذر استخدام الكاميرا والميكروفون",
    H1: "جاهز للانضمام؟",
    P1:
      "لكي يتمكن موظفو خدمة عملاء ASUS من مساعدتك في حل المشكلة بشكل أكثر كفاءة ، يجب أن تسمح للجهاز بالوصول إلى الكاميرا والميكروفون للانضمام إلى غرفة دردشة الفيديو ، ويرجى التأكد من أن اتصال شبكة الهاتف المحمول الخاص بك مستقر ويعمل بشكل طبيعي",
    P2:
      "بعد الوصول ، لا يزال بإمكانك تعيين مفتاح الكاميرا وكتم صوت الميكروفون بحرية ",
    VIDEO_STATE: "حالة الفيديو",
    VIDEO_ON: "تفعيل",
    VIDEO_OFF: "اغلاق",
    AUDIO_STATE: "حالة الصوت",
    AUDIO_ON: "تفعيل",
    AUDIO_OFF: "اغلاق",
    ENTER: "انضم",
    HANGUP: {
      H1: "اغلاق",
      P1: "هل أنت متأكد من إنهاء دردشة الفيديو؟",
      CONFIRM: "تأكيد",
      CANCEL: "الغاء",
    },
    END: {
      H1: "انتهت مكالمة الفيديو",
      P1: "شكرًا لك ، انتهت محادثة الفيديو هذه ، يمكنك إغلاق هذه النافذة.",
    },
  },
  GPT: {
    LAYOUT: {
      STEP_1: "اختر المنتج",
      STEP_2: "شروط الخدمة",
      STEP_3: "تسجيل الدخول",
      STEP_4: "معلومات",
      SELECT_SKILL: "اختر المنتج",
      WELCOME: "مرحباً",
      AGREE: "موافق",
      START: "ابدء",
      CANCEL: "الغاء",
      WAIT: "انتظر من فضلك",
      INPUT: "أدخل النص",
      TRANSFER_TOAGENT: "الانتقال الي الموظف",
      READMORE: "يمكنك أيضًا الرجوع إلى الأسئلة الشائعة ذات الصلة التالية، شكرًا لك.",
      COLLAPSE: "إخفاء",
      INPUT_SN: "الرجاء إعادة إدخال الرقم التسلسلي",
      YOU_MAY_ALSO: "قد ترغب أيضًا في السؤال:",
      FOR_FURTHER: "لمزيد من المعلومات، يرجى الرجوع إلى:",
      RECORDING: "من فضلك ابدأ بالتحدث...",
      RECORDING_NOT_SUPPORTED:
        "متصفحك لا يدعم التعرف على الكلام",
      RECORDING_NOT_FOUND:
        "لم يتم اكتشاف جهاز تسجيل. يُرجى التحقق من الميكروفون والأذونات.",
    },
    IS_COMPONENT_SN:
      "The input is the component serial number, you should enter the correct machine serial number.",
    WARRANTY: {
      SERIES: "نوع المنتج",
      MODEL: "اسم المنتج",
      SERIALNO: "الرقم التسلسلي للمنتج",
      STATUS: "حالة الضمان",
      DATE: "تاريخ انتهاء الضمان",
    },
    HEAD: {
      LEAVE: "Leave",
      CREATE_NEW: "Create New Room",
    },
    ENTRANCE: {
      POLICY: "Privacy Policy",
      AGREE: "Click Agree to start the conversation",
    },
    MESSAGE: {
      WAIT: "Please wait, we are looking for a solution for you.",
    },
    END: "Conversation Ended",
    END_MSG: "We're happy to serve you. The conversation is over.",
    END_SURVEY: "Satisfaction Survey",
    END_SURVEY_MSG: "We're happy to serve you. The conversation is over.",
    BACKHOME: "Return to homepage",
    SURVEY: {
      DESC: "Please rate your experience with ASUS virtual assistant.",
      SAT: "Satisfied",
      DISSAT: "Unsatisfied",
      FEEDBACK: "Please fill in your feedback.",
      SEND: "Send",
      BACK: "Cancel",
    },
    SURVEY_DISLIKE: {
      H1: "Why are you dissatisfied with the answer?",
      P: "Your feedback helps us improve our service quality.",
      BUTTON: "Send",
    },
    HISTORY: {
      TITLE: "History",
      AGO: "منذ {hours} ساعات",
      CONTINUE: "Continue Chat",
      CLOSE: "The conversation has been closed.",
      RESTART: "Restart with Virtual Assistant",
      NON_SERVICE: "Non-Service Hours",
      VIEW_HISTORY: "Click to view the latest chat history.",
    },
  },
};
export default lan;
